export default "__VITE_ASSET__BLOgNcn___"